export const sendDtmfTone = async (call, digit) => {
  if (!call) return;

  try {
    const mapDigitToTone = (tone) => {
      switch (tone) {
        case "0":
          return "Num0";
        case "1":
          return "Num1";
        case "2":
          return "Num2";
        case "3":
          return "Num3";
        case "4":
          return "Num4";
        case "5":
          return "Num5";
        case "6":
          return "Num6";
        case "7":
          return "Num7";
        case "8":
          return "Num8";
        case "9":
          return "Num9";
        case "*":
          return "Star";
        case "#":
          return "Pound";
        default:
          throw new Error(`Invalid DTMF digit: ${tone}`);
      }
    };

    const tone = mapDigitToTone(digit);
    await call.sendDtmf(tone);

    console.log("DTMF sent:", tone);
  } catch (e) {
    console.error("Failed to send DTMF:", e);
  }
};
